import React, { Component } from 'react';
import Radium from 'radium';
import { Redirect } from 'react-router-dom';
import moment from "moment";

import TasksView from "./TasksView";
import DaySelector from "./DaySelector";
import Header from "./Header";
import UserServices from '../services/UserServices';
import TaskServices from "../services/TaskServices";
import update from "react-addons-update";
import SettingsIcon from './SettingsIcon';
import TaskMenu from './TaskMenu';
import {v4 as uuid} from "uuid";

const LEFT_KEY = 37;
const RIGHT_KEY = 39;
const SAVE_WAIT_DELAY = 500;

const DEFAULT_TITLE = "Doer";

const BODY_TAG_NAME = "BODY";
const VISIBLE_STATE = "visible";

class Dashboard extends Component {

	constructor(props) {
		super(props);

		this.tasksView = React.createRef();
		this.keyDownEvent = (evt) => this.onKeyDown(evt);

		this.state = {
			token: localStorage.token,
			tasks: null,
			loading: true,
			selectedBubble: this.getDefaultSelectedBubble(),
			taskMenu: null,
			date: moment(),
			tempId: uuid(),
			completionChanges: false
		};
	}

	getDefaultSelectedBubble() {
		if (!this.props.bubbles) {
			return null;
		}
		
		const defaultBubbleId = UserServices.getPreference(UserServices.DEFAULT_BUBBLE_PREFERENCE);

		if (defaultBubbleId) {
			// Loop through available bubbles to find default
			for (const bubble of this.props.bubbles) {
				if (bubble.id === defaultBubbleId) {
					return bubble;
				}
			}
		}

		return null;
	}

	componentDidMount() {
		window.addEventListener("keydown", this.keyDownEvent);
		document.addEventListener('visibilitychange', (evt) => this.onTabFocusChange(evt));
		this.reloadTasks();
		this.reloadSettings();
	}

	async reloadSettings() {
		const loadedSettings = await UserServices.loadUserSettings();
		this.setState({
			settings: loadedSettings
		});
	}

	componentWillUnmount() {
		window.removeEventListener("keydown", this.keyDownEvent);
	}

	onTabFocusChange(evt) {
		if (this.state.tabState !== document.visibilityState && document.visibilityState === VISIBLE_STATE) {
			this.reloadTasks();
		}
		
		this.setState({
			tabState: document.visibilityState
		});
	}

	getFilteredTasksForBubble() {
		var filtered = [];

		this.state.tasks.forEach((task) => {
			if (this.state.selectedBubble) {
				if (task.bubble_id && task.bubble_id === this.state.selectedBubble.id) {
					filtered.push(task);
				}
			} else {
				if (!task.bubble_id) {
					filtered.push(task);
				}
			}
		});

		return filtered;
	}

	async reloadTasks() {
		this.setState({
			loading: true
		});

		// Clear tasks first to avoid slow connection issues
		//await this.tasksView.current.initialiseTaskState([]);

		try {
			var tasks = await TaskServices.listTasks(this.state.date.format("YYYY-MM-DD"));
			
			await this.setState({
				tasks: tasks
			});

			this.updateTitleBar();

			this.setState({
				completionChanges: false,
				loading: false
			})
		} catch (e) {
			console.error(e);
			this.setState({
				error: e,
				loading: false
			});
		}
	}

	getTitleBarString() {
		if (!this.state.tasks || this.state.tasks.length === 0) {
			return DEFAULT_TITLE;
		} else {
			var str = "";

			this.state.tasks.forEach((task) => {
				if ((this.state.selectedBubble && task.bubble_id && this.state.selectedBubble.id === task.bubble_id) || (!this.state.selectedBubble && !task.bubble_id)) {
					// This is in the correct bubble
					if (task.completed) {
						str += "✅";
					} else {
						str += "⭕️"; 
					}
				}
			});

			if (str.length > 0) {
				return `${DEFAULT_TITLE} | ${str}`;
			}

			return `${DEFAULT_TITLE}`;
			
		}
	}

	updateTitleBar() {
		if (UserServices.getPreference(UserServices.DYNAMIC_TITLE_BAR_ON_PREFERENCE)) {
			document.title = this.getTitleBarString();
		} else {
			document.title = DEFAULT_TITLE;
		}
	}

	onKeyDown(evt) {
		if (evt.srcElement.tagName === BODY_TAG_NAME) {
			if (evt.keyCode === LEFT_KEY) {
				this.onChangeDay(-1);
			} else if (evt.keyCode === RIGHT_KEY) {
				this.onChangeDay(1);
			}
		}
	}

	async onChangeDay(direction) {
		await this.setState({
			date: this.state.date.add(direction, "days"),
			tempId: uuid(),
			completionChanges: false
		});

		this.reloadTasks();
	}

	getTaskIdForTempId(tempId) {
		if (!this.state.tasks) {
			return null;
		}

		for (const task of this.state.tasks) {
			if (task.temp_id && task.temp_id === tempId) {
				// Check if this task now has an id
				if (task.id) {
					return task.id;
				}
			}
		}

		return null;
	}

	async saveChangeRemotely() {
		var taskId = this.state.nextChange.task.task.id;

		if (!taskId) {
			const savedTask = await TaskServices.createTask(this.state.nextChange.date, this.state.nextChange.title, null, this.state.selectedBubble);

			// Loop through and update the ID
			var updatedTasks = update(this.state.tasks, {$apply: (tasks) => {
				for (var i = 0; i < tasks.length; i++) {
					if (tasks[i].temp_id && tasks[i].temp_id === this.state.nextChange.task.task.temp_id) {
						// Updated below - CHANGE THIS IF IT BREAKS
						//tasks[i] = savedTask;
						tasks[i].id = savedTask.id;
						tasks[i].bubble_id = this.state.selectedBubble ? this.state.selectedBubble.id : undefined;
						tasks[i].temp_id = this.state.nextChange.task.task.temp_id;
						break;
					}
				}

				return tasks;
			}});

			this.setState({
				tempId: uuid(),
				tasks: updatedTasks
			});

		} else {
			await TaskServices.editTask(taskId, this.state.nextChange.title, null);
		}

	}

	async setNextChange(task, title) {
		if (this._changeTimer) {
			clearTimeout(this._changeTimer);
		}

		await this.setState({
			nextChange: {
				task: task,
				date: this.state.date,
				title: title,
				bubble_id: this.state.selectedBubble ? this.state.selectedBubble.id : undefined
			}
		});

		this._changeTimer = setTimeout(() => {
			this.saveChangeRemotely();
		}, SAVE_WAIT_DELAY);
	}

	async queueChange(task, title) {
		if (title && title.length > 0) {
			if (this.state.nextChange) {
				// There is already an existing change we may need to persist
				if ((task.task.temp_id && this.state.nextChange.task.task.temp_id === task.task.temp_id) || (task.task.id === this.state.nextChange.task.task.id)) {
					// Overwrite existing change as same task (aka don't persist yet)
					this.setNextChange(task, title);
				} else {
					// Save existing change first
					await this.saveChangeRemotely();
	
					// Set the next change
					this.setNextChange(task, title);
				}
	
			} else {
				this.setNextChange(task, title);
			}
		}
		
	}

	async onChangeTask(task, title) {
		if (title.length === 0) {
			await this.onDeleteTask(task.task);
		} else {
			// Update or add all tasks
			var stateUpdateObj = {
				tempId: uuid()
			};

			var updatedTasks = update(this.state.tasks, {$apply: (tasks) => {
				var found = false;

				for (var i = 0; i < tasks.length; i++) {
					if ((tasks[i].temp_id && tasks[i].temp_id === task.task.temp_id) || tasks[i].id === task.task.id) {
						tasks[i] = task.task;
						found = true;
						break;
					}
				}

				if (!found) { 
					// We are adding
					tasks.push(task.task);
				}

				return tasks;
			}});

			stateUpdateObj.tasks = updatedTasks;

			await this.setState(stateUpdateObj);

			this.updateTitleBar();

			this.queueChange(task, title);
		}	
	}

	async onToggleTaskCompletion(task) {
		TaskServices.completeOrUncompleteTask(task.id, !task.completed);

		var updatedTasks = update(this.state.tasks, {$apply: (tasks) => {
			for (var i = 0; i < tasks.length; i++) {
				if (tasks[i].id === task.id) {
					tasks[i].completed = !tasks[i].completed;
					break;
				}
			}

			return tasks;
		}});

		await this.setState({
			tasks: updatedTasks,
			completionChanges: true
		});

		this.updateTitleBar();

	}

	onAddTask(task) {
		// Update or add all tasks
		var updatedTasks = update(this.state.tasks, {$apply: (tasks) => {
			tasks.push(task);
			return tasks;
		}});

		this.setState({
			tasks: updatedTasks
		});
	}

	async onDeleteTask(task) {
		if (!task.id) {
			return;
		}

		// Delete the task
		TaskServices.deleteTask(task.id);

		var updatedTasks = update(this.state.tasks, {$apply: (tasks) => {
			for (var i = 0; i < tasks.length; i++) {
				if (tasks[i].id === task.id) {
					tasks.splice(i, 1);
					break;
				}
			}
			return tasks;
		}});

		await this.setState({
			tasks: updatedTasks
		});

		this.updateTitleBar();
	}

	async onSelectBubble(bubble) {
		await this.setState({
			selectedBubble: bubble,
			completionChanges: false
		});

		if (bubble) {
			UserServices.savePreference(UserServices.DEFAULT_BUBBLE_PREFERENCE, bubble.id);
		} else {
			UserServices.savePreference(UserServices.DEFAULT_BUBBLE_PREFERENCE, null);
		}
		
		this.updateTitleBar();
	}

	onShowTaskMenu(task, evt) {
		if (!task.id) {
			return;
		}

		const coords = evt.target.getBoundingClientRect();

		this.setState({
			taskMenu: {
				task: task,
				evt: evt,
				x: coords.x,
				y: coords.y,
				height: coords.height,
				width: coords.width
			}
		});
	}

	onHideTaskMenu() {
		this.setState({
			taskMenu: null
		});
	}

	getTasksForView() {
		if (!this.state.tasks) {
			return null;
		}

		var tasks = [];

		//return this.getFilteredTasksForBubble();

		this.state.tasks.forEach((task) => {
			if ((!this.state.selectedBubble && !task.bubble_id) || (this.state.selectedBubble && task.bubble_id && task.bubble_id === this.state.selectedBubble.id)) {
				tasks.push(task);
			}
		});

		return tasks;
	}

	render() {
		if (!localStorage.user || !localStorage.token) {
			return (
				<Redirect to="/login"/>
			);	
		}

		return (
			<div style={this.props.style.global.screenContainer}>
				<Header 
					style={this.props.style}
					subscribed={this.props.subscribed}
					bubbles={this.props.bubbles}
					selectedBubble={this.state.selectedBubble}
					allTasks={this.state.tasks}
					onSelectBubble={(bubble) => this.onSelectBubble(bubble)}/>
				<DaySelector
					date={this.state.date}
					style={this.props.style}
					selectedBubble={this.state.selectedBubble}
					onChangeDay={(direction) => this.onChangeDay(direction)}
				/>
				<TasksView
					ref={this.tasksView}
					date={this.state.date}
					style={this.props.style}
					tasks={this.getTasksForView()}
					completionChanges={this.state.completionChanges}
					tempId={this.state.tempId}
					loading={this.state.loading}
					selectedBubble={this.state.selectedBubble}
					selectedTaskMenu={this.state.taskMenu}
					onChangeTask={(task, title) => this.onChangeTask(task, title)}
					onToggleTaskCompletion={(task) => this.onToggleTaskCompletion(task)}
					onAddTask={(task) => this.onAddTask(task)}
					onDeleteTask={(task) => this.onDeleteTask(task)}
					onShowTaskMenu={(task, evt) => this.onShowTaskMenu(task, evt)}
				/>
				<div style={this.localStyles().icons}>
					
					<SettingsIcon
						style={this.props.style}
						onClick={() => window.location.href = "/settings"}
					/>
					
				</div>
				<TaskMenu
					style={this.props.style}
					taskMenu={this.state.taskMenu}
					onHide={() => this.onHideTaskMenu()}
				/>
			</div>
		);
	}

	localStyles() {
		return {
			icons: {
				position: "absolute",
				bottom: 40,
				right: 40
			}
		}
	}
}

export default Radium(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.js